import { Close } from "@mui/icons-material";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Grid,
} from "@mui/material";
import { useEffect, useState } from "react";

const EditVehicleInfoModal = ({ open, onClose, initialValue, onSave, vehicleInfo }) => {
  const [editedValues, setEditedValues] = useState({
    owners: initialValue,
    make: vehicleInfo?.make || "",
    model: vehicleInfo?.model || "",
    year: vehicleInfo?.year || "",
    mfgDate: vehicleInfo?.mfgDate || "",
    regNo: vehicleInfo?.regNo || "",
    fuel: vehicleInfo?.fuel || "",
    colour: vehicleInfo?.colour || "",
    regDate: vehicleInfo?.regDate || "",
    engineCC: vehicleInfo?.engineCC || "",
    engineNumber: vehicleInfo?.engineNumber || "",
    chassisNumber: vehicleInfo?.chassisNumber || "",
  });

  useEffect(() => {
    setEditedValues({
      owners: initialValue,
      make: vehicleInfo?.make || "",
      model: vehicleInfo?.model || "",
      year: vehicleInfo?.year || "",
      mfgDate: vehicleInfo?.mfgDate || "",
      regNo: vehicleInfo?.regNo || "",
      fuel: vehicleInfo?.fuel || "",
      colour: vehicleInfo?.colour || "",
      regDate: vehicleInfo?.regDate || "",
      engineCC: vehicleInfo?.engineCC || "",
      engineNumber: vehicleInfo?.engineNumber || "",
      chassisNumber: vehicleInfo?.chassisNumber || "",
    });
  }, [initialValue, vehicleInfo]);

  const handleFieldChange = (field, value) => {
    setEditedValues((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSave = () => {
    console.log(editedValues, "editedValues");
    onSave(editedValues);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        Edit Vehicle Information
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              type="number"
              label="Number of Owners"
              value={editedValues.owners}
              onChange={(e) => handleFieldChange("owners", e.target.value)}
              inputProps={{ min: 0, max: 10 }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Make"
              value={editedValues.make}
              onChange={(e) => handleFieldChange("make", e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Model"
              value={editedValues.model}
              onChange={(e) => handleFieldChange("model", e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Year"
              value={editedValues.year}
              onChange={(e) => handleFieldChange("year", e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="MfgDate"
              value={editedValues.mfgDate}
              onChange={(e) => handleFieldChange("mfgDate", e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Registration Number"
              value={editedValues.regNo}
              onChange={(e) => handleFieldChange("regNo", e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Fuel Type"
              value={editedValues.fuel}
              onChange={(e) => handleFieldChange("fuel", e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Colour"
              value={editedValues.colour}
              onChange={(e) => handleFieldChange("colour", e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Registration Date"
              value={editedValues.regDate}
              onChange={(e) => handleFieldChange("regDate", e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Engine CC"
              value={editedValues.engineCC}
              onChange={(e) => handleFieldChange("engineCC", e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Engine Number"
              value={editedValues.engineNumber}
              onChange={(e) => handleFieldChange("engineNumber", e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Chassis Number"
              value={editedValues.chassisNumber}
              onChange={(e) => handleFieldChange("chassisNumber", e.target.value)}
            />
          </Grid>
        </Grid>
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 3 }}>
          <Button onClick={onClose}>Cancel</Button>
          <Button variant="contained" onClick={handleSave} sx={{ bgcolor: "#003cc5" }}>
            Save
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default EditVehicleInfoModal;
